<div class="container mx-auto mt-4">
  <app-document-verify
    *ngIf="!isShowingPQRForm"
    (documentNumberValidated)="showPQRForm($event)"
  ></app-document-verify>
  <app-pqrform
    *ngIf="isShowingPQRForm"
    [documentInformation]="documentInformation"
    (pqrSent)="handlePqrSent()"
  ></app-pqrform>
</div>
